import { useStore } from 'vuex';
import store from '@/store';
import { modalNames } from '@/components/common/globalComponent';
export const modalList = {
  ...modalNames
};

export const show = (component, data = {}, tag = '') => {
  store.dispatch('layout/pushModalComponent', { component, data });
};
export const showDoneModal = (
  contents,
  doneText,
  cancelText,
  doneCallback,
  leftInnerClass = null,
  rightInnerClass = null,
  title = null,
  cancelCallback = null
) => {
  show(modalList.CONFIRM, {
    contents,
    doneText,
    cancelText,
    doneCallback,
    leftInnerClass,
    rightInnerClass,
    title,
    cancelCallback
  });
};
export const showTextModal = (contents, callBackText, fnCallBack = null, btnClass = null) => {
  show(modalList.ALERT, { contents, callBackText, fnCallBack, btnClass });
};

export const showLoginModal = (callBack, doneText = '로그인하기') => {
  show(modalList.CONFIRM, {
    contents: '로그인 후 이용 가능합니다.',
    cancelText: '취소',
    doneText: doneText,
    doneCallback: callBack
  });
};

export const alertShow = async (component, data = {}) => {
  await store.dispatch('layout/pushModalAlertComponent', { component, data });
};
export const close = (tag = '') => {
  if (!tag) return store.dispatch('layout/removeAllModalComponent');
  const attachedList = store.getters['layout/getModalComponents'].map(elem => elem.tag);

  const index = attachedList.findIndex(v => {
    if (v === tag) return v;
  });
  return store.dispatch('layout/closeModalComponent', { index });
};

export const useModalState = () => {
  const store = useStore();

  const fnModalConfirm = async (title, contents, callBackDone) => {
    const payload = {};
    payload.component = modalNames.CONFIRM;
    payload.layout = {
      title: title,
      contents: contents
    };
    payload.callBackDone = proxy => {
      proxy.$emit('close');
      callBackDone();
    };
    payload.callBackCancel = proxy => {
      proxy.$emit('close');
    };
    await store.dispatch('layout/pushModalAlertComponent', payload);
  };

  const fnModalAlert = async (title, contents, callBack) => {
    if (callBack === undefined || typeof callBack !== 'function') {
      callBack = () => {
        store.dispatch('layout/closeModalAlertComponent', {
          index: store.getters['layout/getModalAlertComponents'].length - 1
        });
      };
    }
    const payload = {};
    payload.component = modalNames.BASE;
    payload.layout = {
      title: title,
      contents: contents
    };
    payload.callBack = callBack;
    await store.dispatch('layout/pushModalAlertComponent', payload);
  };

  return {
    fnModalConfirm,
    fnModalAlert
  };
};
